import { render, staticRenderFns } from "./ColaboradoresCadastroUnico.vue?vue&type=template&id=13585f1c"
import script from "./ColaboradoresCadastroUnico.vue?vue&type=script&lang=js"
export * from "./ColaboradoresCadastroUnico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports